module.exports = __webpack_public_path__ + "static/media/hangman2.6f411b18.png";